export default "__VITE_ASSET__CO8te237__"